<script lang="ts">
import { ThemeType } from '@goodlifeplus/themes'
import { defineAsyncComponent, defineComponent } from 'vue'

/**
 * The "Home" layout provider.
 */
export default defineComponent({
  components: {
    HomeClubView: defineAsyncComponent(() => import('./HomeClubView.vue')),
    HomeView: defineAsyncComponent(() => import('./HomeView.vue')),
  },
  setup() {
    return {
      ThemeType,
    }
  },
}) as new (...args: any[]) => any // lifted from vue/test-utils
</script>

<template>
  <HomeClubView v-if="$theme.type === ThemeType.Club" />
  <HomeView v-else />
</template>
